import HubspotForm from '@/components/ui/hubspot-form/hubspot-form'
import { TypeComponentHubSpotForm } from '@/types/ctf'
import './newsletter.css'
import { cx } from '@/utils/strings'

type NewsletterProps = {
  form: TypeComponentHubSpotForm<'WITHOUT_UNRESOLVABLE_LINKS'>['fields']
  size?: 'Small' | 'Large'
}

export default function Newsletter({ form, size = 'Large' }: NewsletterProps) {
  return (
    <div className={cx('bw-newsletter', size === 'Small' && 'small')}>
      <HubspotForm {...form} />
    </div>
  )
}
